class AlgoliaRecommendations {
    constructor() {
      this.apiKey = '7062e9f2f73e621d5fc108f04a358055';
      this.appId = '94EFJRUBNN';
      this.indexName = 'shopify_prod_products';
      this.baseUrl = 'https://94efjrubnn-dsn.algolia.net/1/indexes/*/recommendations';
    }
  
    async getBoughtTogether(variantId, maxResults = 30) {
      const requestBody = {
        requests: [{
          model: "bought-together",
          indexName: this.indexName,
          maxRecommendations: maxResults,
          threshold: 20,
          objectID: String(variantId)
        }]
      };
  
      try {
        const response = await fetch(this.baseUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Algolia-API-Key': this.apiKey,
            'X-Algolia-Application-Id': this.appId
          },
          body: JSON.stringify(requestBody)
        });
  
        if (!response.ok) {
          throw new Error(`Algolia API error: ${response.status}`);
        }
  
        const data = await response.json();
        return data.results?.[0]?.hits || [];
      } catch (error) {
        console.error('Error fetching Algolia recommendations:', error);
        return [];
      }
    }
}